<template>
  <li class="node">
    <a
      v-if="node.children && node.children.length"
      @click="openChildren"
      class="hasChild"
      :class="{openchild:true?openchild:false}"
    >
      <span>{{ node.Name }}</span>
    </a>
    <a v-else @click="goToProducts(node.parentId)">
      <span>{{ node.Name }}</span>
    </a>
    <ul v-if="node.children && node.children.length" :class="{open:true?open:false}">
      <node v-for="(child,index) in node.children" :node="child" :key="index"></node>
    </ul>
  </li>
</template>

<script>
export default {
  name: "node",
  props: {
    node: Object,
  },
  data() {
    return {
      open: false,
      openchild: false,
    };
  },
  methods: {
    openChildren() {
      if (this.open == false && this.openchild == false) {
        (this.open = true), (this.openchild = true);
      } else {
        (this.open = false), (this.openchild = false);
      }
    },
    goToProducts(categoryId) {
      this.$router.push({ name: "Products", params: { id: categoryId } });
    },
  },
};
</script>

<style  scoped>
.tree ul {
  padding: 0 15px;
  margin: 5px 0;
  display: none;
}
.tree ul.open {
  display: block;
}
.tree > li {
  margin-bottom: 15px;
}
.tree a {
  color: #333;
  font-size: 13pt;
  display: block;
  position: relative;
  margin-bottom: 15px;
  cursor: pointer;
}
.tree > li > a {
  display: block;
  color: #6a1b9a;
  font-size: 15pt;
  border-bottom: 1px solid #6a1b9a;
  display: block;
  padding-bottom: 15px;
  cursor: pointer;
  position: relative;
  margin-bottom: 15px;
}
.tree > li > a:after {
  content: "\F140";
  font-family: "Material Design Icons";
  position: absolute;
  left: 0px;
  font-size: 20pt;
  line-height: 1;
  top: 8px;
  font-weight: normal;
  border: 0;
  margin: 0;
}
.tree > li > ul > li {
  border-bottom: 1px dotted;
  margin-bottom: 15px;
}
.tree > li > ul > li > a {
  display: block;
  color: #6a1b9a;
  font-size: 14pt;
  padding: 5px 10px;
}
.tree > li > ul > li > a.hasChild {
  position: relative;
}
.tree > li > ul > li > a.hasChild:after {
  content: "+";
  position: absolute;
  left: 15px;
  top: 6px;
  font-size: 15pt;
}
.tree > li > ul > li > a.openchild.hasChild {
  color: #fff;
  background: #6a1b9a;
}
.tree > li > ul > li > a.openchild.hasChild:after {
  content: "-";
}
@media all and (max-width: 992px) {
  .tree a {
    font-size: 11pt;
  }
  .tree > li > a {
    font-size: 13pt;
  }
  .tree > li > ul > li > a {
    font-size: 12pt;
  }
}
@media all and (max-width: 576px) {
  .tree a {
    font-size: 8pt;
    margin-bottom: 5px;
  }
  .tree > li {
    margin-bottom: 0;
  }
  .tree > li > a {
    font-size: 9pt;
    margin-bottom: 0;
    padding-bottom: 5px;
  }
  .tree > li > ul > li > a {
    font-size: 8.5pt;
    padding: 5px;
    margin: 0;
  }
  .tree > li > ul > li {
    margin-bottom: 0;
  }
  .tree > li > a:after {
    font-size: 15pt;
    top: 4px;
  }
  .tree > li > ul > li > a.hasChild:after {
    top: 5px;
    font-size: 11pt;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/products/category/Node.vue